import { render, staticRenderFns } from "./CVariantTaxes.vue?vue&type=template&id=f9970dec"
import script from "./CVariantTaxes.vue?vue&type=script&lang=js"
export * from "./CVariantTaxes.vue?vue&type=script&lang=js"
import style0 from "./CVariantTaxes.vue?vue&type=style&index=0&id=f9970dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@babel+core@8.0.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack_3967ed8cd784b60b7f0fd1a71945913e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports